import { API_ROUTES } from '@/constants/apiRoutes';
import { client } from '@/services/client/client';

export interface Attribute {
  label: string;
  labelEng: string;
  value: string;
}

export const getAttributes = async ({ queryKey }: { queryKey: [string, string, string | null] }) => {
  const [, flag, value1] = queryKey;

  const data = await client.get<{ data: Attribute[] }>(API_ROUTES.GET_COMMON_ATTRIBUTE, { params: { flag, value1 } });
  return data;
};
